export const DataGridIdentifiers = Object.freeze({
  simpleTaskReports: 'simpleTaskReports',
  Projects: 'Projects',
  AbsenceReports: 'AbsenceReports',
  CompanyActive: 'CompanyActive',
  CompanyDayOff: 'CompanyDayOff',
  MachineActive: 'MachineActive',
  MachineDayOff: 'MachineDayOff',
  attendance: 'attendance',
  AttendanceUsers: 'AttendanceUsers',
  biHead: 'biHead',
  biReport: 'biReport',
  Company: 'Company',
  CompanyLocationTable: 'CompanyLocationTable',
  InnovationReports: 'InnovationReports',
  MachineTable: 'MachineTable',
  OperationReports: 'OperationReports',
  PriorityReports: 'PriorityReports',
  ProductionPersons: 'ProductionPersons',
  ProductionReports: 'ProductionReports',
  OperationReportTable: 'OperationReportTable',
  ProductionReportDialog: 'ProductionReportDialog',
  ProjectContact: 'ProjectContact',
  ProjectHoliday: 'ProjectHoliday',
  ProjectGroupReports: 'ProjectGroupReports',
  FormsDataGrid: 'FormsDataGrid',
  PropertyReports: 'PropertyReports',
  SelectListDatagrid: 'SelectListDatagrid',
  QuantityUnitReports: 'QuantityUnitReports',
  ResourceFourReports: 'ResourceFourReports',
  operations: 'operations',
  dependencies: 'dependencies',
  TypeFormTable: 'TypeFormTable',
  TypeReports: 'TypeReports',
  UserReports: 'UserReports',
  StatusReports: 'StatusReports',
  TaskReports: 'TaskReports',
  StatusFormTable: 'StatusFormTable',
  CompanyFormTable: 'CompanyFormTable',
  InnovationFormTable: 'InnovationFormTable',
  PriorityFormTable: 'PriorityFormTable',
  ProductionFormTable: 'ProductionFormTable',
  ProductionItem: 'ProductionItem',
  ProjectGroupListFormTable: 'ProjectGroupListFormTable',
  simpleTaskRespPersonlist: 'simpleTaskRespPersonlist',
  ResourceOneTable: 'ResourceOneTable',
  ResourceTwoTable: 'ResourceTwoTable',
  ResourceThreeTable: 'ResourceThreeTable',
  ResourceFourTable: 'ResourceFourTable',
  ResourceFiveTable: 'ResourceFiveTable',
  resourceOne: 'resourceOne',
  communication: 'communication',
  resourceTwo: 'resourceTwo',
  resourceThree: 'resourceThree',
  companyContact: 'companyContact',
  province: 'province',
  provinceDayOff: 'provinceDayOff',
  uploadFile: 'uploadedFile',
  dashboardReports: 'dashboardReports',
  complaints: 'complaints',
  classificationReports: 'classificationReports',
  classificationItems: 'classificationItems',
  crmTask: 'crmTask',
  groupsDataGrid: 'groupsDataGrid',
  vehiclePlanDatagrid: 'vehiclePlanDatagrid',
  projectCommunication: 'projectCommunication',
  item: 'item',
  projectSimpleTaskHistory: 'projectSimpleTaskHistory',
  checkListTemplate: 'checkListTemplate',
  checkListTemplateItem: 'checkListTemplateItem',
  checkListItem: 'checkListItem',
  CompanyContact: 'CompanyContact',
  sourceList: 'sourceList',
  assemblyDefinition: 'assemblyDefinition',
  inventoryConversion: 'inventoryConversion',
  assemblyDefinitionLine: 'assemblyDefinitionLine',
  sourceListOperation: 'sourceListOperation',
  sourceListItem: 'sourceListItem',
  sourceListOperationMachine: 'sourceListOperationMachine',
  SapShiftLeaderReport: 'SapShiftLeaderReport',
  planAbsenceReports: 'planAbsenceReports',
  documentTypes: 'documentTypes',
  docLine: 'docLine',
  documentReports: 'documentReports',
  vatReports: 'vatReports',
  taskListTemplate: 'taskListTemplate',
  taskListTemplateItem: 'taskListTemplateItem',
  projectTaskList: 'projectTaskList',
  currencyList: 'currencyList',
  vatCodeList: 'vatCodeList',
  countryList: 'countryList',
  languageList: 'languageList',
  expiryMonitoring: 'expiryMonitoring',
  SupplierComplaintList: 'SupplierComplaintList',
  CorrectionList: 'CorrectionList',
  priceList: 'priceList',
  paymentMethod: 'paymentMethod',
  warehouse: 'warehouse',
  companyGroup: 'companyGroup',
  exchangeRate: 'exchangeRate',
  kshClassification: 'kshClassification',
  salesOrPurchasePerson: 'salesOrPurchasePerson',
  deliveryMethod: 'deliveryMethod',
  costCenter: 'costCenter',
  itemGroup: 'itemGroup',
  incoterm: 'incoterm',
  propertyGroup: 'propertyGroup',
  companyAddress: 'companyAddress',
  operationGroup: 'operationGroup',
  documentLine: 'documentLine',
  productionStatusTable: 'productionStatusTable',
  ProductionGeneratorTable: 'ProductionGeneratorTable',
  ProductionGeneratorNewProdTable: 'ProductionGeneratorNewProdTable',
  productionStore: 'productionStore',
  wmsDeliveryDocs: 'wmsDeliveryDocs',
  wmsDeliveryBaseDocLines: 'wmsDeliveryBaseDocLines',
  wmsPurchaseDeliveryDocs: 'wmsPurchaseDeliveryDocs',
  wmsPurchaseDeliveryBaseDocLines: 'wmsPurchaseDeliveryBaseDocLines',
  conversion: 'conversion',
  template: 'template',
  emailMessage: 'emailMessage',
  templateItem: 'templateItem',
  templateItemOperation: 'templateItemOperation',
  taskListDialog: 'taskListDialog',
  taskListImport: 'taskListImport',
  ProductionPlannerTable: 'ProductionPlannerTable',
  DowntimeReasonTable: 'DowntimeReasonTable',
  InterruptionReasonTable: 'InterruptionReasonTable',
  userGroup: 'userGroup',
  favouriteMenu: 'favouriteMenu',
  employeePlannerAbsence: 'employeePlannerAbsence',
  ProductionItemProposalTable: 'ProductionItemProposalTable',
  buildingCommunication: 'buildingCommunication',
  buildingReport: 'buildingReport',
  scrapReason: 'scrapReason',
  eventTable: 'eventTable',
  projectTaskLists: 'projectTaskLists',
  otherExpenseLine: 'otherExpenseLine',
  otherExpense: 'otherExpense',
  DynamicFormCreatorList: 'DynamicFormCreatorList',
  DynamicFormField: 'DynamicFormField',
  taskFeedback: 'taskFeedback',
  activityLogTable: 'activityLogTable',
  companyHistory: 'companyHistory',
  SalesQuotationDoc: 'SalesQuotationDoc',
  CustomerOrderDoc: 'CustomerOrderDoc',
  DeliveryNoteDoc: 'DeliveryNoteDoc',
  ReturnDoc: 'ReturnDoc',
  DownPaymentRequestDoc: 'DownPaymentRequestDoc',
  DownPaymentDoc: 'DownPaymentDoc',
  ARInvoiceDoc: 'ARInvoiceDoc',
  PurchaseRequestDoc: 'PurchaseRequestDoc',
  PurchaseQuotationDoc: 'PurchaseQuotationDoc',
  PurchaseOrderDoc: 'PurchaseOrderDoc',
  PurchaseDeliveryNoteDoc: 'PurchaseDeliveryNoteDoc',
  GoodsReturnDoc: 'GoodsReturnDoc',
  APDownPaymentRequestDoc: 'APDownPaymentRequestDoc',
  PurchaseAdvanceInvoiceDoc: 'PurchaseAdvanceInvoiceDoc',
  APInvoiceDoc: 'APInvoiceDoc',
  PurchaseOrderVariantDoc: 'PurchaseOrderVariantDoc',
  InventoryTransferDoc: 'InventoryTransferDoc',
  GoodsReceiptDoc: 'GoodsReceiptDoc',
  GoodsIssueDoc: 'GoodsIssueDoc',
  ProjectIssueDoc: 'ProjectIssueDoc',
  CooperationIssueDoc: 'CooperationIssueDoc',
  EmployeeIssueDoc: 'EmployeeIssueDoc',
  InventoryCountingDoc: 'InventoryCountingDoc',
  InventoryCountingDifDoc: 'InventoryCountingDifDoc',
  ReceiptFromProductionDoc: 'ReceiptFromProductionDoc',
  IssueForProductionDoc: 'IssueForProductionDoc',
  ProductionOrderDoc: 'ProductionOrderDoc',
  SalesQuotationDocLine: 'SalesQuotationDocLine',
  CustomerOrderDocLine: 'CustomerOrderDocLine',
  DeliveryNoteDocLine: 'DeliveryNoteDocLine',
  ReturnDocLine: 'ReturnDocLine',
  DownPaymentRequestDocLine: 'DownPaymentRequestDocLine',
  DownPaymentDocLine: 'DownPaymentDocLine',
  ARInvoiceDocLine: 'ARInvoiceDocLine',
  PurchaseRequestDocLine: 'PurchaseRequestDocLine',
  PurchaseQuotationDocLine: 'PurchaseQuotationDocLine',
  PurchaseOrderDocLine: 'PurchaseOrderDocLine',
  PurchaseDeliveryNoteDocLine: 'PurchaseDeliveryNoteDocLine',
  GoodsReturnDocLine: 'GoodsReturnDocLine',
  APDownPaymentRequestDocLine: 'APDownPaymentRequestDocLine',
  PurchaseAdvanceInvoiceDocLine: 'PurchaseAdvanceInvoiceDocLine',
  APInvoiceDocLine: 'APInvoiceDocLine',
  PurchaseOrderVariantDocLine: 'PurchaseOrderVariantDocLine',
  InventoryTransferDocLine: 'InventoryTransferDocLine',
  GoodsReceiptDocLine: 'GoodsReceiptDocLine',
  GoodsIssueDocLine: 'GoodsIssueDocLine',
  ProjectIssueDocLine: 'ProjectIssueDocLine',
  CooperationIssueDocLine: 'CooperationIssueDocLine',
  EmployeeIssueDocLine: 'EmployeeIssueDocLine',
  InventoryCountingDocLine: 'InventoryCountingDocLine',
  InventoryCountingDifDocLine: 'InventoryCountingDifDocLine',
  ReceiptFromProductionDocLine: 'ReceiptFromProductionDocLine',
  IssueForProductionDocLine: 'IssueForProductionDocLine',
  ProductionOrderDocLine: 'ProductionOrderDocLine',
  ProductionIssue: 'ProductionIssue',
  ProductionReceipt: 'ProductionReceipt',
  ProductionReturnIssuedBatchTable: 'ProductionReturnIssuedBatchTable',
  ProductionReturnSelectedBatchTable: 'ProductionReturnSelectedBatchTable',
  BatchTable: 'BatchTable',
  BatchOutTable: 'BatchOutTable',
  BatchInStockTable: 'BatchInStockTable',
  companyBreakLine: 'companyBreakLine',
  companyBreak: 'companyBreak',
  FpProdGeneratorTable: 'FpProdGeneratorTable',
  FpProductionGeneratorNewProdTable: 'FpProductionGeneratorNewProdTable',
  DetailProdTable: 'DetailProdTable',
  DetailFromWarehouseTable: 'DetailFromWarehouseTable',
  SourceSalesQuotationDoc: 'SourceSalesQuotationDoc',
  SourceSalesQuotationDocLine: 'SourceSalesQuotationDocLine',
  SourceCustomerOrderDoc: 'SourceCustomerOrderDoc',
  SourceCustomerOrderDocLine: 'SourceCustomerOrderDocLine',
  SourceDeliveryNoteDoc: 'SourceDeliveryNoteDoc',
  SourceDeliveryNoteDocLine: 'SourceDeliveryNoteDocLine',
  SourceReturnDoc: 'SourceReturnDoc',
  SourceReturnDocLine: 'SourceReturnDocLine',
  SourceDownPaymentRequestDoc: 'SourceDownPaymentRequestDoc',
  SourceDownPaymentRequestDocLine: 'SourceDownPaymentRequestDocLine',
  SourceDownPaymentDoc: 'SourceDownPaymentDoc',
  SourceDownPaymentDocLine: 'SourceDownPaymentDocLine',
  SourceARInvoiceDoc: 'SourceARInvoiceDoc',
  SourceARInvoiceDocLine: 'SourceARInvoiceDocLine',
  SourcePurchaseRequestDoc: 'SourcePurchaseRequestDoc',
  SourcePurchaseRequestDocLine: 'SourcePurchaseRequestDocLine',
  SourcePurchaseQuotationDoc: 'SourcePurchaseQuotationDoc',
  SourcePurchaseQuotationDocLine: 'SourcePurchaseQuotationDocLine',
  SourcePurchaseOrderDoc: 'SourcePurchaseOrderDoc',
  SourcePurchaseOrderDocLine: 'SourcePurchaseOrderDocLine',
  SourcePurchaseDeliveryNoteDoc: 'SourcePurchaseDeliveryNoteDoc',
  SourcePurchaseDeliveryNoteDocLine: 'SourcePurchaseDeliveryNoteDocLine',
  SourceGoodsReturnDoc: 'SourceGoodsReturnDoc',
  SourceGoodsReturnDocLine: 'SourceGoodsReturnDocLine',
  SourceAPDownPaymentRequestDoc: 'SourceAPDownPaymentRequestDoc',
  SourceAPDownPaymentRequestDocLine: 'SourceAPDownPaymentRequestDocLine',
  SourcePurchaseAdvanceInvoiceDoc: 'SourcePurchaseAdvanceInvoiceDoc',
  SourcePurchaseAdvanceInvoiceDocLine: 'SourcePurchaseAdvanceInvoiceDocLine',
  SourceAPInvoiceDoc: 'SourceAPInvoiceDoc',
  SourceAPInvoiceDocLine: 'SourceAPInvoiceDocLine',
  SourcePurchaseOrderVariantDoc: 'SourcePurchaseOrderVariantDoc',
  SourcePurchaseOrderVariantDocLine: 'SourcePurchaseOrderVariantDocLine',
  SourceInventoryTransferDoc: 'SourceInventoryTransferDoc',
  SourceInventoryTransferDocLine: 'SourceInventoryTransferDocLine',
  SourceGoodsReceiptDoc: 'SourceGoodsReceiptDoc',
  SourceGoodsReceiptDocLine: 'SourceGoodsReceiptDocLine',
  SourceGoodsIssueDoc: 'SourceGoodsIssueDoc',
  SourceGoodsIssueDocLine: 'SourceGoodsIssueDocLine',
  SourceProjectIssueDoc: 'SourceProjectIssueDoc',
  SourceProjectIssueDocLine: 'SourceProjectIssueDocLine',
  SourceCooperationIssueDoc: 'SourceCooperationIssueDoc',
  SourceCooperationIssueDocLine: 'SourceCooperationIssueDocLine',
  SourceEmployeeIssueDoc: 'SourceEmployeeIssueDoc',
  SourceEmployeeIssueDocLine: 'SourceEmployeeIssueDocLine',
  SourceInventoryCountingDoc: 'SourceInventoryCountingDoc',
  SourceInventoryCountingDocLine: 'SourceInventoryCountingDocLine',
  SourceInventoryCountingDifDoc: 'SourceInventoryCountingDifDoc',
  SourceInventoryCountingDifDocLine: 'SourceInventoryCountingDifDocLine',
  SourceReceiptFromProductionDoc: 'SourceReceiptFromProductionDoc',
  SourceReceiptFromProductionDocLine: 'SourceReceiptFromProductionDocLine',
  SourceIssueForProductionDoc: 'SourceIssueForProductionDoc',
  SourceIssueForProductionDocLine: 'SourceIssueForProductionDocLine',
  SourceProductionOrderDoc: 'SourceProductionOrderDoc',
  SourceProductionOrderDocLine: 'SourceProductionOrderDocLine',
  IssueForServiceDoc: 'IssueForServiceDoc',
  IssueForServiceDocLine: 'IssueForServiceDocLine',
  ReceiptFromServiceDoc: 'ReceiptFromServiceDoc',
  ReceiptFromServiceDocLine: 'ReceiptFromServiceDocLine',
  SourceIssueForServiceDoc: 'SourceIssueForServiceDoc',
  SourceIssueForServiceDocLine: 'SourceIssueForServiceDocLine',
  SourceReceiptFromServiceDoc: 'SourceReceiptFromServiceDoc',
  SourceReceiptFromServiceDocLine: 'SourceReceiptFromServiceDocLine',
  sourceDoc: 'sourceDoc',
  sourceDocLine: 'sourceDocLine',
  DocumentPrevPrices: 'DocumentPrevPrices',
  ProjectHistory: 'ProjectHistory',
  itemPriceTable: 'itemPriceTable',
  DownPaymentDialog: 'DownPaymentDialog',
  discountRuleTable: 'discountRuleTable',
  ProductionConfirmation: 'ProductionConfirmation',
  ProjectType: 'ProjectType',
  ProjectTaskListReportsTable: 'ProjectTaskListReportsTable',
  ServiceStatus: 'ServiceStatus',
  ItemCompanyCatalog: 'ItemCompanyCatalog',
  DocumentItemCompanyCatalogDialog: 'DocumentItemCompanyCatalogDialog',
  CustomDocStatus: 'CustomDocStatus',
  ServiceTaskType: 'ServiceTaskType',
  WorkArea: 'WorkArea',
  ServiceOperation: 'ServiceOperation',
  ServiceOperationMaterial: 'ServiceOperationMaterial',
  ServiceOperationCheckList: 'ServiceOperationCheckList',
  ServiceGroup: 'ServiceGroup',
  Service: 'Service',
  ServiceMaterial: 'ServiceMaterial',
  ServiceTask: 'ServiceTask',
  ServiceTaskChecklist: 'ServiceTaskChecklist',
  ServiceIssue: 'ServiceIssue',
  ProjectTypeStatusItems: 'ProjectTypeStatusItems',
  ResourcesTable: 'ResourcesTable',
  ItemType: 'ItemType',
  ItemTypeProperty: 'ItemTypeProperty',
  ItemTypePropertyValues: 'ItemTypePropertyValues',
  ComplaintReason: 'ComplaintReason',
  ComplaintType: 'ComplaintType',
  ComplaintStatus: 'ComplaintStatus',
  ComplaintResolution: 'ComplaintResolution',
  ComplaintResolutionRequest: 'ComplaintResolutionRequest',
  ComplaintActionTaken: 'ComplaintActionTaken',
  ComplaintCore: 'ComplaintCore',
  ServiceAccounting: 'ServiceAccounting',
  TaskListReportsTable: 'TaskListReportsTable',
  ComplaintReport8D: 'ComplaintReport8D',
  ComplaintReport4D: 'ComplaintReport4D',
  ComplaintReportTeam: 'ComplaintReportTeam',
  ComplaintReportAction: 'ComplaintReportAction',
  ComplaintReportPermanentAction: 'ComplaintReportPermanentAction',
  ComplaintReportSolution: 'ComplaintReportSolution',
  ComplaintEffect: 'ComplaintEffect',
  Conformity: 'Conformity',
  ConformityComponent: 'ConformityComponent',
  CompanyBank: 'CompanyBank',
  AlertForm: 'AlertForm',
  AlertRecipient: 'AlertRecipient',
  AlertMessage: 'AlertMessage',
  AlertMsg: 'AlertMsg',
  TaskListRespPersonTable: 'TaskListRespPersonTable',
  Budget: 'Budget',
  BudgetLine: 'BudgetLine',
  ResourceFive: 'ResourceFive',
  VatDetermination: 'VatDetermination',
  PlanTaskReports: 'PlanTaskReports',
  PlanTaskTaskReports: 'PlanTaskTaskReports',
  PlanTaskRespPerson: 'PlanTaskRespPerson',
  DeadLineNotification: 'DeadLineNotification',
  SimpleTaskShedule: 'SimpleTaskShedule',
  AttendanceSettlementProjectTable: 'AttendanceSettlementProjectTable',
  AttendanceSettlementTable: 'AttendanceSettlementTable',
  AttendanceSettlement: 'AttendanceSettlement',
  AttendanceSettlementLine: 'AttendanceSettlementLine',
  ProjectPriceTable: 'ProjectPriceTable',
  ProjectPrice: 'ProjectPrice',
  BinTable: 'BinTable',
  BinOutTable: 'BinOutTable',
  BinBatchOutTable: 'BinBatchOutTable',
  BinInStockTable: 'BinInStockTable',
  BinBatchInStockTable: 'BinBatchInStockTable',
  ReturnFromProductionDoc: 'ReturnFromProductionDoc',
  ReturnFromProductionDocLine: 'ReturnFromProductionDocLine',
  SourceReturnFromProductionDoc: 'SourceReturnFromProductionDoc',
  SourceReturnFromProductionDocLine: 'SourceReturnFromProductionDocLine',
  ProdGeneratorPartialTable: 'ProdGeneratorPartialTable',
  ProductionGeneratorPartialNewProdTable: 'ProductionGeneratorPartialNewProdTable',
  OrderExecution: 'OrderExecution',
  ResourceOneRole: 'ResourceOneRole',
  ItemStockTable: 'ItemStockTable',
  wmsDeliveryInProgress: 'wmsDeliveryInProgress',
  BatchSn: 'BatchSn',
  wmsInventoryTransferInProgress: 'wmsInventoryTransferInProgress',
  wmsPurchaseDeliveryInProgress: 'wmsPurchaseDeliveryInProgress',
  ReturnFromIssueDoc: 'ReturnFromIssueDoc',
  ProjectReturnDoc: 'ProjectReturnDoc',
  CooperationReturnDoc: 'CooperationReturnDoc',
  EmployeeReturnDoc: 'EmployeeReturnDoc',
  ReturnFromIssueDocLine: 'ReturnFromIssueDocLine',
  ProjectReturnDocLine: 'ProjectReturnDocLine',
  CooperationReturnDocLine: 'CooperationReturnDocLine',
  EmployeeReturnDocLine: 'EmployeeReturnDocLine',
  SourceReturnFromIssueDoc: 'SourceReturnFromIssueDoc',
  SourceProjectReturnDoc: 'SourceProjectReturnDoc',
  SourceCooperationReturnDoc: 'SourceCooperationReturnDoc',
  SourceEmployeeReturnDoc: 'SourceEmployeeReturnDoc',
  SourceReturnFromIssueDocLine: 'SourceReturnFromIssueDocLine',
  SourceProjectReturnDocLine: 'SourceProjectReturnDocLine',
  SourceCooperationReturnDocLine: 'SourceCooperationReturnDocLine',
  SourceEmployeeReturnDocLine: 'SourceEmployeeReturnDocLine',
  MaterialPlanLineView: 'MaterialPlanLineView',
  MaterialPlanReports: 'MaterialPlanReports',
  EmployeeReports: 'EmployeeReports',
  EmployeesResourcesTable: 'EmployeesResourcesTable',
  EmployeeAttendanceReports: 'EmployeeAttendanceReports',
  EmployeeAttendanceLine: 'EmployeeAttendanceLine',
  EmployeeAttendanceReportTable: 'EmployeeAttendanceReportTable',
  ProjectEmployeeTable: 'ProjectEmployeeTable',
  JokerSelectListTable: 'JokerSelectListTable',
  ResourceOneGroupTable: 'ResourceOneGroupTable',
  ProjectPaymentScheduleTable: 'ProjectPaymentScheduleTable',
  EmployeeAttendanceMyReportsTable: 'EmployeeAttendanceMyReportsTable',
  ProjectSubcontractorsTable: 'ProjectSubcontractorsTable',
  ProjectEmployeeAttendanceDetailsTable: 'ProjectEmployeeAttendanceDetailsTable',
  ProjectExtraWorkSimpleTasksTable: 'ProjectExtraWorkSimpleTasksTable',
  ProjectSimpleTasksTable: 'ProjectSimpleTasksTable',
  TagReportTable: 'TagReportTable',
  RelatedItemTable: 'RelatedItemTable',
  EmployeePrice: 'EmployeePrice',
  EmployeeAbsenceReports: 'EmployeeAbsenceReports',
  supportingDocumentType: 'supportingDocumentType',
  supportingDocumentTypeReports: 'supportingDocumentTypeReports',
  supportingDocument: 'supportingDocument',
  CompanySalesPerson: 'CompanySalesPerson',
  EmployeeLine: 'EmployeeLine',
  FolderTemplateReport: 'FolderTemplateReport',
  FolderTemplateItem: 'FolderTemplateItem',
});
